import React from 'react';
import { Cell } from '../Cell';
import classNames from 'classnames';
import './index.scss';
import { JumpType, navigate } from '@home/utils/utils';
import hyperlink from '@/pages/dashboard/assets/svg/hyperlink.svg';
import { IMarkdownLinkCellProps } from './type';

export const MarkdownLinkCell = (props: IMarkdownLinkCellProps) => {
  const { className, style, value, config } = props;
  const { jumpType = JumpType.Window, color = '#326FF0' } = config || {};

  const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/;
  const safeValue = typeof value === 'string' ? value : String(value ?? '');
  const match = safeValue.match(markdownLinkRegex) || null;

  const label = match?.[1];
  const url = match?.[2];

  const handleClick = () => {
    if (!url) return;
    navigate(url, { jumpType });
  };

  return (
    <Cell
      className={classNames('dbd-common-table__markdown-link-cell', className)}
      style={style}
    >
      <div
        className="dbd-common-table__markdown-link-cell-onClick-wrapper"
        onClick={handleClick}
      >
        {label ? (
          <>
            <span style={{ color }}>{label}</span>
            {url && <img src={hyperlink} alt="hyperlink" />}
          </>
        ) : (
          '-'
        )}
      </div>
    </Cell>
  );
};